// extracted by mini-css-extract-plugin
module.exports = {"merchantCopy":"purify_index__merchantCopy--2Occa","icon":"purify_index__icon--1iGpJ","text":"purify_index__text--iROtV"};